import styled, { keyframes } from 'styled-components';

const toastIn = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: ${({ theme }) => theme.space[4]};
  left: ${({ theme }) => theme.space[4]};
  right: ${({ theme }) => theme.space[4]};
  z-index: ${({ theme }) => theme.zIndex.toast};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  pointer-events: none;
`;

export const ToastItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[4]};
  background: ${({ theme, type }) =>
    type === 'error' ? theme.colors.error :
    type === 'success' ? '#0d6832' :
    theme.colors.gray900};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  font-size: ${({ theme }) => theme.fonts.sm};
  max-width: 400px;
  width: 100%;
  pointer-events: auto;
  animation: ${toastIn} ${({ theme }) => theme.transitions.base};
`;

export const ToastMessage = styled.span`
  flex: 1;
`;

export const ToastClose = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: ${({ theme }) => theme.space[1]};
  display: flex;
  align-items: center;

  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
`;
